export default __webpack_public_path__ + "static/media/search.eba2e65e.svg";